import { render } from "./Gemeindenachmittag.vue?vue&type=template&id=4a6977c0"
import script from "./Gemeindenachmittag.vue?vue&type=script&lang=js"
export * from "./Gemeindenachmittag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__